module.exports = require("@material-ui/core/Tabs");